<template>
    <div class="mesas">
        <h1>Control de mesas</h1>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-data-table
                        :headers="headers"
                        :items="mesas"
                        :items-per-page="10"
                        :search="search"
                        class="elevation-0 mesas-table"
                    >
                        <template v-slot:top>
                            <v-container fluid>
                                <v-row>
                                    <v-col>
                                        <v-select
                                            v-model="election_id"
                                            :item-text="textItemElection"
                                            :items="elecciones"
                                            :loading="isLoading"
                                            class="mx-4"
                                            item-value="id"
                                            label="Selecciona elección"
                                            @change="fetchMesas"
                                        >
                                        </v-select>
                                    </v-col>
                                </v-row>
                                <v-row v-if="election_id">
                                    <v-col>
                                        <v-text-field
                                            v-model="search"
                                            :disabled="isLoading"
                                            :loading="isLoading"
                                            class="mx-4"
                                            label="Buscar"
                                        ></v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>

                                    <v-col class="text-right">
                                        <v-btn
                                            :loading="isLoading"
                                            class="mr-1 white--text"
                                            color="green"
                                            @click="fetchMesas"
                                        >
                                            <i class="fa fa-sync-alt"></i>
                                        </v-btn>
                                        <v-btn
                                            :disabled="
                                                isLoading ||
                                                    !isCurrentElectionActive
                                            "
                                            :loading="isLoading"
                                            class="white--text"
                                            color="red"
                                            @click="askAllModal = true"
                                        >
                                            Aperturar todas las mesas
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                        <template v-slot:[`item.opened_by`]="{ item }">
                            <div class="text-no-wrap">
                                <b>
                                    <small> {{ item.codigo }} <br /> </small>
                                </b>
                                {{ item.nombre }} <br />
                                <small>
                                    {{ item.opened_at }}
                                </small>
                            </div>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn
                                v-if="item.opened_by === null"
                                :disabled="!isCurrentElectionActive"
                                class="white--text"
                                color="green"
                                small
                                @click="
                                    selectedMesa = item;
                                    askModal = true;
                                "
                            >
                                <i class="fa fa-box-open"></i>
                                &nbsp; Aperturar
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="askModal" :persistent="isLoading" max-width="400">
            <v-card>
                <v-card-title class="headline">
                    ¿Estás seguro?
                </v-card-title>
                <v-card-text>
                    Estás a punto de aperturar la mesa
                    {{ selectedMesa.mesa_id }} en
                    <br />
                    {{ selectedMesa.desc_ures }}
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="askModal = false">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="isLoading"
                        color="green darken-1"
                        text
                        @click="openStation"
                    >
                        Sí, continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="askAllModal" :persistent="isLoading" max-width="400">
            <v-card>
                <v-card-title class="headline">
                    ¿Estás seguro?
                </v-card-title>
                <v-card-text>
                    Estás a punto de aperturar todas las mesas pendientes.
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="askAllModal = false">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="isLoading"
                        color="green darken-1"
                        text
                        @click="openAll"
                    >
                        Sí, continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { DateTime } from 'luxon';

export default {
    data() {
        return {
            headers: [
                {
                    text: 'URES',
                    value: 'ures',
                },
                {
                    text: 'Desc URES',
                    value: 'desc_ures',
                },
                {
                    text: 'Mesa',
                    value: 'mesa_id',
                },
                {
                    text: 'Estatus',
                    value: 'status',
                },
                {
                    text: 'Aperturada por',
                    value: 'opened_by',
                },

                {
                    text: '',
                    value: 'actions',
                },
            ],
            isLoading: false,
            election_id: null,
            search: '',
            askModal: false,
            askAllModal: false,
            selectedMesa: {},
        };
    },
    computed: {
        ...mapGetters({
            _mesas: 'mesas/mesas',
            elecciones: 'elecciones/elecciones',
        }),
        _currentElection() {
            if (!this.election_id) {
                return null;
            }
            return this.elecciones.find(
                election => election.id === this.election_id
            );
        },
        mesas() {
            if (!this.election_id) {
                return [];
            }
            return this._mesas;
        },
        isCurrentElectionActive() {
            if (!this._currentElection) {
                return false;
            }

            const now = DateTime.now();
            const startAt = DateTime.fromISO(this._currentElection.start);
            const endAt = DateTime.fromISO(this._currentElection.end);

            return now >= startAt && now <= endAt;
        },
    },
    methods: {
        ...mapActions({
            _fetchMesas: 'mesas/fetchMesas',
            _openStation: 'mesas/openStation',
            _getElections: 'elecciones/getElecciones',
        }),
        textItemElection: item =>
            `${item.id} | ${item.description} | ${item.type.toUpperCase()}`,
        openAll() {
            const now = DateTime.now();
            const startAt = DateTime.fromISO(this._currentElection.start);
            const endAt = DateTime.fromISO(this._currentElection.end);

            if (now < startAt || now > endAt) {
                this.$store.dispatch(
                    'errorMessage',
                    'La elección no está en curso'
                );
                return;
            }

            this.isLoading = true;
            this._openStation({
                election_id: this.election_id,
                mesa_id: 'all',
            })
                .then(response => {
                    this.askAllModal = false;
                    if (
                        response &&
                        Array.isArray(response.errors) &&
                        response.errors.length > 0
                    ) {
                        if (response.errors.includes('eleccion_finished')) {
                            this.$store.dispatch(
                                'errorMessage',
                                'La elección ha terminado'
                            );
                        } else {
                            this.$store.dispatch(
                                'errorMessage',
                                'No se pudo aperturar todas las mesas'
                            );
                        }

                        return;
                    }

                    this.$store.dispatch('mesas/fetchMesas', {
                        election_id: this.election_id,
                    });
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openStation() {
            const now = DateTime.now();
            const startAt = DateTime.fromISO(this._currentElection.start);
            const endAt = DateTime.fromISO(this._currentElection.end);

            if (now < startAt || now > endAt) {
                this.$store.dispatch(
                    'errorMessage',
                    'La elección no está en curso'
                );
                return;
            }

            this.isLoading = true;
            this._openStation({
                election_id: this.election_id,
                mesa_id: this.selectedMesa.mesa_id,
            })
                .then(response => {
                    this.askModal = false;

                    if (
                        response &&
                        Array.isArray(response.errors) &&
                        response.errors.length > 0
                    ) {
                        if (response.errors.includes('eleccion_finished')) {
                            this.$store.dispatch(
                                'errorMessage',
                                'La elección ha terminado'
                            );
                        } else {
                            this.$store.dispatch(
                                'errorMessage',
                                'No se pudo aperturar todas las mesas'
                            );
                        }

                        return;
                    }

                    this.$store.dispatch('mesas/fetchMesas', {
                        election_id: this.election_id,
                    });
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        fetchMesas() {
            this.isLoading = true;
            this._fetchMesas({ election_id: this.election_id })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getElections() {
            this._getElections()
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    created() {
        this.getElections();
    },
};
</script>

<style scoped lang="scss">
.mesas {
    padding: 10px;

    &-table {
        margin-bottom: 10px;
    }

    &-dates {
        background-color: white;
        padding: 50px 0 0;
    }
}

.btn {
    margin: 0 10px;
}
</style>
